<template>
  <BaseMemberSelect
    v-model="feedbackSenderIds"
    class="bg-surface-container-high"
    :error="props.membersError"
    :filter="props.memberFilter"
    :autofocus="props.autofocusMembers"
    :show-select-all-button="props.showSelectAllButton"
    :label="label"
    display-selected="list"
  />
</template>

<script setup lang="ts">
  import BaseMemberSelect from '@/core/components/base/member-select/BaseMemberSelect.vue'

  interface Props {
    membersError?: string
    autofocusMembers?: boolean
    memberFilter?: 'coachees' | 'all'
    showSelectAllButton?: boolean
    label?: string
  }

  const props = withDefaults(defineProps<Props>(), {
    membersError: undefined,
    recurrenceIntervalError: undefined,
    showMembers: true,
    showRecurrence: true,
    autofocusMembers: false,
    memberFilter: 'coachees',
  })

  const feedbackSenderIds = defineModel<string[]>('feedbackSenderIds', { required: true })
</script>
